import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetAllV2fxAccountApi = (params) => api.get(`usermaster/vertex-account-trader?${qs(params)}`);
export const GetAllAccountTypeApi = (data) => api.post(`planmaster/get-active-plan-for-user`, data); // get-all-plan-for-user
export const CreateAccountTypeApi = (data) => api.post('trading/trader/create-trading-account', data);
export const UpdateAccountLeverageApi = (data) => api.put('trading/trading-leverage-change', data);
export const UpdateAccountPasswordApi = (data) => api.put('trading/trading-change-password', data);
export const VerifyLoginPasswordApi = (data) => api.post('usermaster/verify-password', data);
export const AddAccountbalanceApi = (data) => api.post('trading/trading-demo-account-deposit', data);
export const UpdateMT5AccountACtypeApi = (data) => api.put('PlanAccountType/Change-Plan-Type-ByUser', data);
